export default __webpack_public_path__ + "static/SRF 4700PW - Fiche de spécifications et données techniques-330b8bca02ec6895b564ab27899d63c4.pdf";